import React from 'react';
import { Container, Typography } from '@mui/material';

const AccessibilityPage = () => {
  return (
    <Container>
      <Typography variant="h4">Acessibilidade</Typography>
      <Typography>
        Ferramentas para facilitar o acesso de todos.
      </Typography>
    </Container>
  );
};

export default AccessibilityPage;
